import { render, staticRenderFns } from "./yszc.vue?vue&type=template&id=0548d69a&scoped=true&"
import script from "./yszc.vue?vue&type=script&lang=js&"
export * from "./yszc.vue?vue&type=script&lang=js&"
import style0 from "./yszc.vue?vue&type=style&index=0&id=0548d69a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0548d69a",
  null
  
)

export default component.exports